import { Icon, Menu } from '@percent/lemonade'
import { VolunteeringActionsMenuProps } from './VolunteeringActionsMenu.types'

export function VolunteeringActionsMenu({ handleSelect, items }: VolunteeringActionsMenuProps) {
  return (
    <Menu title={<Icon name="menu-vertical" size={6} />} onSelect={key => handleSelect(key)} sections={[{ items }]} />
  )
}
